import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid } from 'recharts';
const CARD_STYLE: React.CSSProperties = {
  border: '1px solid #E4E4E4',
  borderRadius: '8px',
  boxShadow: 'none'
};
const HEADING_FONT = "'RobotoCondensed VariableFont Wght', Roboto Condensed, sans-serif";
const statoPieData = [{
  name: 'Aperti',
  value: 4,
  color: '#293B54'
}, {
  name: 'In Lavorazione',
  value: 3,
  color: '#98C3EC'
}, {
  name: 'Chiusi',
  value: 3,
  color: '#D7EDFF'
}];
const bandoPieData = [{
  name: 'Bando 1 - Nuove Opere',
  value: 61.5,
  color: '#293B54'
}, {
  name: 'Bando 3 - Professionalizzazione',
  value: 19.4,
  color: '#0E74B8'
}, {
  name: 'Bando 2 - Scuole',
  value: 12.4,
  color: '#98C3EC'
}, {
  name: 'Bando 4 - Live',
  value: 7.7,
  color: '#D7EDFF'
}];
const stats = [{
  label: 'Totale Ticket',
  value: 10,
  icon: 'tabler:ticket'
}, {
  label: 'Aperti',
  value: 4,
  icon: 'tabler:folder-open'
}, {
  label: 'In Lavorazione',
  value: 3,
  icon: 'tabler:clock'
}, {
  label: 'Chiusi',
  value: 3,
  icon: 'tabler:circle-check'
}];
const detailStats = [{
  label: 'Tempo medio risposta',
  value: '4.2 ore'
}, {
  label: 'Ticket per operatore',
  value: '3.3'
}, {
  label: 'Tasso chiusura',
  value: '30%'
}, {
  label: 'Ticket alta priorità',
  value: '4'
}];
const ARGOMENTI_COLORS = ['#293B54', '#00497A', '#0E74B8', '#2A97DF', '#98C3EC', '#D7EDFF', '#98C3EC', '#D7EDFF'];
const argomentiData = [{
  name: 'Rendicontazione',
  value: 28,
  color: '#293B54'
}, {
  name: 'Accesso e Autenticazione',
  value: 22,
  color: '#00497A'
}, {
  name: 'Caricamento Allegati',
  value: 18,
  color: '#0E74B8'
}, {
  name: 'Scadenze e Proroghe',
  value: 15,
  color: '#2A97DF'
}, {
  name: 'Budget e Costi',
  value: 12,
  color: '#98C3EC'
}, {
  name: 'Documentazione',
  value: 10,
  color: '#D7EDFF'
}, {
  name: 'Stato Candidatura',
  value: 8,
  color: '#98C3EC'
}, {
  name: 'Comunicazioni',
  value: 5,
  color: '#D7EDFF'
}];
const argomentiTotal = argomentiData.reduce((sum, d) => sum + d.value, 0);
const blockingPoints = [{
  title: 'Upload allegati superiori a 10MB',
  desc: 'Il sistema non fornisce feedback chiaro sul limite di dimensione file.',
  count: 18,
  severity: 'Critico'
}, {
  title: 'Timeout autenticazione SPID',
  desc: 'Sessioni che scadono durante la compilazione, causando perdita dati.',
  count: 14,
  severity: 'Critico'
}, {
  title: 'Validazione codice CUP',
  desc: 'Formato non validato in tempo reale, errore scoperto solo al submit.',
  count: 9,
  severity: 'Alto'
}, {
  title: 'Navigazione rendicontazione',
  desc: 'Struttura a tab non intuitiva per inserimento giustificativi.',
  count: 7,
  severity: 'Medio'
}];
const causePrincipali = [{
  label: 'Problemi di Interfaccia/UX',
  pct: 32,
  count: 32
}, {
  label: 'Documentazione Insufficiente',
  pct: 24,
  count: 24
}, {
  label: 'Errori Tecnici',
  pct: 20,
  count: 20
}, {
  label: 'Mancanza di Informazioni',
  pct: 14,
  count: 14
}, {
  label: 'Complessità del Processo',
  pct: 10,
  count: 10
}];
const raccomandazioni = [{
  title: 'Implementare validazione real-time dei campi',
  desc: 'Validazione lato client per CUP, codice fiscale e partita IVA.',
  impact: '-30% ticket tecnici'
}, {
  title: 'Aumentare limite upload a 25MB',
  desc: 'Limite attuale insufficiente. Implementare upload chunked.',
  impact: '-18 ticket/mese'
}, {
  title: 'Salvataggio automatico bozza',
  desc: 'Salvataggio ogni 30s per prevenire perdite da timeout SPID.',
  impact: '-14 ticket/mese'
}, {
  title: 'Riprogettare navigazione rendicontazione',
  desc: 'Wizard guidato step-by-step con progress indicator.',
  impact: '-25% tempo supporto'
}];
const tabs = [{
  id: 'panoramica',
  label: 'Panoramica'
}, {
  id: 'analisi-raccomandazioni',
  label: 'Analisi & Raccomandazioni'
}, {
  id: 'analisi-gestione',
  label: 'Analisi Gestione'
}];
export function AnalisiTicket() {
  const [activeTab, setActiveTab] = useState('panoramica');
  return <div className="space-y-6 pb-12" style={{
    fontFamily: 'Roboto, sans-serif'
  }} data-id="element-321">
      {/* Page Header + Tab Bar */}
      <div className="bg-white" style={CARD_STYLE} data-id="element-322">
        <div className="px-4 md:px-8 pt-4 md:pt-6" data-id="element-323">
          <h1 style={{
          fontSize: '24px',
          fontWeight: 400,
          color: '#293B54',
          fontFamily: 'Roboto, sans-serif',
          margin: 0
        }} data-id="element-324">
            Analisi Ticket
          </h1>
        </div>
        <div className="flex items-end overflow-x-auto px-4 md:px-8" data-id="element-325">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className="whitespace-nowrap" style={{
          padding: '14px 20px 12px',
          cursor: 'pointer',
          color: activeTab === tab.id ? '#293B54' : '#AAAAAA',
          borderBottom: activeTab === tab.id ? '2px solid #2A97DF' : '2px solid transparent',
          fontFamily: HEADING_FONT,
          fontSize: '14px',
          fontWeight: activeTab === tab.id ? 500 : 400,
          marginBottom: '-1px',
          background: 'transparent',
          borderTop: 'none',
          borderLeft: 'none',
          borderRight: 'none',
          outline: 'none',
          letterSpacing: '0.2px'
        }} data-id="element-326">
              {tab.label}
            </button>)}
        </div>
      </div>

      {/* TAB: Panoramica */}
      {activeTab === 'panoramica' && <div className="space-y-6" data-id="element-327">
          {/* Stats Row */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-328">
            {stats.map((stat, i) => <div key={i} className="bg-white flex flex-col justify-between p-4 md:p-6" style={CARD_STYLE} data-id="element-329">
                <div className="mb-3" data-id="element-330">
                  <Icon icon={stat.icon} fontSize={22} style={{
              color: '#2A97DF',
              strokeWidth: 1.5
            }} data-id="element-331" />
                </div>
                <div data-id="element-332">
                  <div style={{
              fontFamily: 'Roboto Condensed, sans-serif',
              color: '#293B54',
              lineHeight: 1.2
            }} className="text-[24px] font-[400]" data-id="element-333">
                    {stat.value}
                  </div>
                  <div style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '14px',
              color: '#80858E',
              marginTop: '4px'
            }} data-id="element-334">
                    {stat.label}
                  </div>
                </div>
              </div>)}
          </div>
          <div className="grid grid-cols-12 gap-6" data-id="element-335">
            {/* Distribuzione per Stato */}
            <div className="col-span-12 md:col-span-5" data-id="element-336">
              <div className="bg-white h-full p-4 md:p-7" style={CARD_STYLE} data-id="element-337">
                <h2 style={{
              fontSize: '16px',
              fontWeight: 400,
              color: '#293B54',
              fontFamily: HEADING_FONT,
              margin: '0 0 20px 0'
            }} data-id="element-338">
                  Distribuzione per Stato
                </h2>
                <div className="flex flex-col gap-4" data-id="element-339">
                  {statoPieData.map((item, idx) => {
                const maxVal = Math.max(...statoPieData.map(d => d.value));
                return <div key={idx} className="flex items-center gap-3" style={{
                  minHeight: '28px'
                }} data-id="element-340">
                        <div className="w-[80px] md:w-[120px] flex-shrink-0 text-[13px] text-[#444444] font-roboto whitespace-nowrap overflow-hidden text-ellipsis" title={item.name} data-id="element-341">
                          {item.name}
                        </div>
                        <div className="flex-1" style={{
                    height: '20px',
                    backgroundColor: '#F0F1F3',
                    borderRadius: '3px',
                    overflow: 'hidden'
                  }} data-id="element-342">
                          <div style={{
                      height: '100%',
                      width: `${item.value / maxVal * 100}%`,
                      backgroundColor: item.color,
                      borderRadius: '0 3px 3px 0',
                      minWidth: '2px'
                    }} data-id="element-343" />
                        </div>
                        <span style={{
                    fontFamily: HEADING_FONT,
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#293B54',
                    minWidth: '28px',
                    textAlign: 'right',
                    flexShrink: 0
                  }} data-id="element-344">
                          {item.value}
                        </span>
                      </div>;
              })}
                </div>
              </div>
            </div>

            {/* Distribuzione per Bando */}
            <div className="col-span-12 md:col-span-7" data-id="element-345">
              <div className="bg-white h-full p-4 md:p-7" style={CARD_STYLE} data-id="element-346">
                <h2 style={{
              fontSize: '16px',
              fontWeight: 400,
              color: '#293B54',
              fontFamily: HEADING_FONT,
              margin: '0 0 20px 0'
            }} data-id="element-347">
                  Distribuzione per Bando
                </h2>
                <div className="flex flex-col gap-4" data-id="element-348">
                  {bandoPieData.map((item, idx) => {
                const maxVal = Math.max(...bandoPieData.map(d => d.value));
                return <div key={idx} className="flex items-center gap-3" style={{
                  minHeight: '28px'
                }} data-id="element-349">
                        <div className="w-[120px] md:w-[220px] flex-shrink-0 text-[13px] text-[#444444] font-roboto whitespace-nowrap overflow-hidden text-ellipsis" title={item.name} data-id="element-350">
                          {item.name}
                        </div>
                        <div className="flex-1" style={{
                    height: '20px',
                    backgroundColor: '#F0F1F3',
                    borderRadius: '3px',
                    overflow: 'hidden'
                  }} data-id="element-351">
                          <div style={{
                      height: '100%',
                      width: `${item.value / maxVal * 100}%`,
                      backgroundColor: item.color,
                      borderRadius: '0 3px 3px 0',
                      minWidth: '2px'
                    }} data-id="element-352" />
                        </div>
                        <span style={{
                    fontFamily: HEADING_FONT,
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#293B54',
                    minWidth: '48px',
                    textAlign: 'right',
                    flexShrink: 0
                  }} data-id="element-353">
                          {item.value}%
                        </span>
                      </div>;
              })}
                </div>
              </div>
            </div>
          </div>
        </div>}

      {/* TAB: Analisi & Raccomandazioni */}
      {activeTab === 'analisi-raccomandazioni' && <div className="space-y-6" data-id="element-354">
          {/* Argomenti Prevalenti */}
          <div className="bg-white p-4 md:p-7" style={CARD_STYLE} data-id="element-355">
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 gap-4" data-id="element-356">
              <h2 style={{
            fontSize: '16px',
            fontWeight: 400,
            color: '#293B54',
            fontFamily: HEADING_FONT,
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }} data-id="element-357">
                Argomenti Prevalenti
                <span style={{
              backgroundColor: '#F5F5F5',
              color: '#80858E',
              fontSize: '10px',
              fontFamily: HEADING_FONT,
              padding: '2px 6px',
              borderRadius: '4px',
              fontWeight: 500
            }} data-id="element-358">
                  AI
                </span>
              </h2>
              <div className="flex flex-wrap items-center gap-3" data-id="element-359">
                <div className="flex items-center gap-2" style={{
              backgroundColor: 'rgba(41, 59, 84, 0.07)',
              borderRadius: '4px',
              padding: '4px 10px'
            }} data-id="element-360">
                  <Icon icon="tabler:trending-up" fontSize={14} style={{
                color: '#293B54'
              }} data-id="element-361" />
                  <span style={{
                fontSize: '12px',
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                fontWeight: 400
              }} data-id="element-362">
                    Rendicontazione
                  </span>
                  <span style={{
                fontSize: '12px',
                color: '#293B54',
                fontFamily: HEADING_FONT,
                fontWeight: 500
              }} data-id="element-363">
                    +45%
                  </span>
                </div>
                <div className="flex items-center gap-2" style={{
              backgroundColor: '#F5F5F5',
              borderRadius: '4px',
              padding: '4px 10px'
            }} data-id="element-364">
                  <Icon icon="tabler:trending-down" fontSize={14} style={{
                color: '#98C3EC'
              }} data-id="element-365" />
                  <span style={{
                fontSize: '12px',
                color: '#80858E',
                fontFamily: 'Roboto, sans-serif',
                fontWeight: 400
              }} data-id="element-366">
                    Accesso
                  </span>
                  <span style={{
                fontSize: '12px',
                color: '#80858E',
                fontFamily: HEADING_FONT,
                fontWeight: 500
              }} data-id="element-367">
                    -12%
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-368">
              {/* Donut Chart */}
              <div style={{
            height: '280px',
            position: 'relative'
          }} data-id="element-369">
                <ResponsiveContainer width="100%" height="100%" data-id="element-370">
                  <PieChart data-id="element-371">
                    <Pie data={argomentiData} cx="50%" cy="50%" innerRadius={70} outerRadius={120} paddingAngle={0} dataKey="value" isAnimationActive={false} label={({
                  cx,
                  cy,
                  midAngle,
                  innerRadius,
                  outerRadius,
                  index
                }) => {
                  const RADIAN = Math.PI / 180;
                  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
                  const x = cx + radius * Math.cos(-midAngle * RADIAN);
                  const y = cy + radius * Math.sin(-midAngle * RADIAN);
                  return <text x={x} y={y} fill={argomentiData[index].color === '#D7EDFF' ? '#293B54' : 'white'} textAnchor="middle" dominantBaseline="central" fontSize={10} fontWeight={500} data-id="element-373">
                            {argomentiData[index].value}
                          </text>;
                }} labelLine={false} data-id="element-372">
                      {argomentiData.map((entry, index) => <Cell key={`argomento-${index}`} fill={entry.color} stroke="none" strokeWidth={0} data-id="element-374" />)}
                    </Pie>
                    <Tooltip contentStyle={{
                  borderRadius: '6px',
                  border: '1px solid #E4E4E4',
                  boxShadow: 'none',
                  fontSize: '13px'
                }} formatter={(value: number) => [`${value} ticket`, '']} data-id="element-375" />
                  </PieChart>
                </ResponsiveContainer>
                {/* Center label */}
                <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
              pointerEvents: 'none'
            }} data-id="element-376">
                  <div style={{
                fontSize: '28px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: HEADING_FONT,
                lineHeight: 1
              }} data-id="element-377">
                    {argomentiTotal}
                  </div>
                  <div style={{
                fontSize: '11px',
                color: '#80858E',
                marginTop: '4px'
              }} data-id="element-378">
                    Ticket totali
                  </div>
                </div>
              </div>

              {/* Legend List */}
              <div className="flex flex-col justify-center gap-1" data-id="element-379">
                {argomentiData.map((item, idx) => {
              const pct = (item.value / argomentiTotal * 100).toFixed(1);
              return <div key={idx} className="flex items-center gap-3" style={{
                padding: '8px 0',
                borderBottom: idx < argomentiData.length - 1 ? '1px solid #F5F5F5' : 'none'
              }} data-id="element-380">
                      <div style={{
                  width: '10px',
                  height: '10px',
                  borderRadius: '2px',
                  backgroundColor: item.color,
                  flexShrink: 0,
                  border: item.color === '#D7EDFF' ? '1px solid #E4E4E4' : 'none'
                }} data-id="element-381" />
                      <span style={{
                  fontSize: '13px',
                  color: '#444444',
                  flex: 1
                }} data-id="element-382">
                        {item.name}
                      </span>
                      <span style={{
                  fontFamily: HEADING_FONT,
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#293B54',
                  minWidth: '32px',
                  textAlign: 'right'
                }} data-id="element-383">
                        {item.value}
                      </span>
                      <span style={{
                  fontSize: '12px',
                  color: '#AAAAAA',
                  minWidth: '48px',
                  textAlign: 'right'
                }} data-id="element-384">
                        {pct}%
                      </span>
                    </div>;
            })}
              </div>
            </div>
          </div>

          {/* Blocking Points */}
          <div data-id="element-385">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-386">
              {blockingPoints.map((bp, idx) => {
            const severityColor = bp.severity === 'Critico' ? '#EA5455' : bp.severity === 'Alto' ? '#E96E00' : '#2A97DF';
            const severityBg = bp.severity === 'Critico' ? 'rgba(234, 84, 85, 0.08)' : bp.severity === 'Alto' ? 'rgba(233, 110, 0, 0.08)' : 'rgba(42, 151, 223, 0.08)';
            return <div key={idx} className="bg-white p-4 md:p-6" style={{
              ...CARD_STYLE,
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }} data-id="element-387">
                    <div className="flex items-center justify-between gap-3" data-id="element-388">
                      <span style={{
                  fontSize: '10px',
                  fontWeight: 500,
                  color: severityColor,
                  fontFamily: HEADING_FONT,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  padding: '2px 8px',
                  backgroundColor: severityBg,
                  borderRadius: '3px'
                }} data-id="element-389">
                        {bp.severity}
                      </span>
                      <div className="flex items-center gap-1.5" style={{
                  flexShrink: 0
                }} data-id="element-390">
                        <span style={{
                    fontFamily: HEADING_FONT,
                    fontSize: '18px',
                    fontWeight: 500,
                    color: '#293B54',
                    lineHeight: 1
                  }} data-id="element-391">
                          {bp.count}
                        </span>
                        <span style={{
                    fontSize: '11px',
                    color: '#AAAAAA'
                  }} data-id="element-392">
                          ticket
                        </span>
                      </div>
                    </div>
                    <div data-id="element-393">
                      <div style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#293B54',
                  marginBottom: '4px',
                  lineHeight: 1.4
                }} data-id="element-394">
                        {bp.title}
                      </div>
                      <p style={{
                  fontSize: '13px',
                  color: '#80858E',
                  margin: 0,
                  lineHeight: 1.5
                }} data-id="element-395">
                        {bp.desc}
                      </p>
                    </div>
                  </div>;
          })}
            </div>
          </div>

          {/* Raccomandazioni */}
          <div className="flex items-center justify-between mb-6" data-id="element-396">
            <h2 style={{
          fontSize: '16px',
          fontWeight: 400,
          color: '#293B54',
          fontFamily: HEADING_FONT,
          margin: 0,
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }} data-id="element-397">
              Raccomandazioni
              <span style={{
            backgroundColor: '#F5F5F5',
            color: '#80858E',
            fontSize: '10px',
            fontFamily: HEADING_FONT,
            padding: '2px 6px',
            borderRadius: '4px',
            fontWeight: 500
          }} data-id="element-398">
                AI
              </span>
            </h2>
            <span style={{
          fontSize: '11px',
          color: '#AAAAAA'
        }} data-id="element-399">
              Aggiornato: 16 Mag 2025
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-400">
            {raccomandazioni.map((rec, idx) => <div key={idx} className="p-4 md:p-6" style={{
          border: '1px solid #E4E4E4',
          borderRadius: '8px',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          backgroundColor: '#FFFFFF'
        }} data-id="element-401">
                <div className="flex items-center justify-between gap-3" data-id="element-402">
                  <div className="flex items-center gap-2" data-id="element-403">
                    <span style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                backgroundColor: 'rgba(42, 151, 223, 0.1)',
                color: '#2A97DF',
                fontSize: '12px',
                fontWeight: 500,
                fontFamily: HEADING_FONT,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }} data-id="element-404">
                      {idx + 1}
                    </span>
                    <span style={{
                fontSize: '10px',
                fontWeight: 500,
                color: '#2e7d32',
                fontFamily: HEADING_FONT,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                padding: '2px 8px',
                backgroundColor: 'rgba(46, 125, 50, 0.08)',
                borderRadius: '3px'
              }} data-id="element-405">
                      {rec.impact}
                    </span>
                  </div>
                  <Icon icon="tabler:bulb" fontSize={16} style={{
              color: '#2A97DF',
              flexShrink: 0
            }} data-id="element-406" />
                </div>
                <div data-id="element-407">
                  <div style={{
              fontSize: '14px',
              fontWeight: 500,
              color: '#293B54',
              marginBottom: '4px',
              lineHeight: 1.4
            }} data-id="element-408">
                    {rec.title}
                  </div>
                  <p style={{
              fontSize: '13px',
              color: '#80858E',
              margin: 0,
              lineHeight: 1.5
            }} data-id="element-409">
                    {rec.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>}

      {/* TAB: Analisi Gestione */}
      {activeTab === 'analisi-gestione' && <div className="space-y-6" data-id="element-410">
          {/* Impatto KPI Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-411">
            <div className="bg-white flex flex-col justify-between p-4 md:p-6" style={CARD_STYLE} data-id="element-412">
              <div className="mb-3" data-id="element-413">
                <Icon icon="tabler:clock" fontSize={22} style={{
              color: '#2A97DF',
              strokeWidth: 1.5
            }} data-id="element-414" />
              </div>
              <div data-id="element-415">
                <div style={{
              fontFamily: 'Roboto Condensed, sans-serif',
              color: '#293B54',
              lineHeight: 1.2
            }} className="text-[24px] font-[400]" data-id="element-416">
                  4.2 ore
                </div>
                <div style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '14px',
              color: '#80858E',
              marginTop: '4px'
            }} data-id="element-417">
                  Tempo Medio Risoluzione
                </div>
              </div>
            </div>

            <div className="bg-white flex flex-col justify-between p-4 md:p-6" style={CARD_STYLE} data-id="element-418">
              <div className="mb-3" data-id="element-419">
                <Icon icon="tabler:repeat" fontSize={22} style={{
              color: '#2A97DF',
              strokeWidth: 1.5
            }} data-id="element-420" />
              </div>
              <div data-id="element-421">
                <div style={{
              fontFamily: 'Roboto Condensed, sans-serif',
              color: '#293B54',
              lineHeight: 1.2
            }} className="text-[24px] font-[400]" data-id="element-422">
                  23%
                </div>
                <div style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '14px',
              color: '#80858E',
              marginTop: '4px'
            }} data-id="element-423">
                  Ticket Ricorrenti
                </div>
              </div>
            </div>

            <div className="bg-white flex flex-col justify-between p-4 md:p-6" style={CARD_STYLE} data-id="element-424">
              <div className="mb-3" data-id="element-425">
                <Icon icon="tabler:mood-happy" fontSize={22} style={{
              color: '#2A97DF',
              strokeWidth: 1.5
            }} data-id="element-426" />
              </div>
              <div data-id="element-427">
                <div style={{
              fontFamily: 'Roboto Condensed, sans-serif',
              color: '#293B54',
              lineHeight: 1.2
            }} className="text-[24px] font-[400]" data-id="element-428">
                  78%
                </div>
                <div style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '14px',
              color: '#80858E',
              marginTop: '4px'
            }} data-id="element-429">
                  Soddisfazione
                </div>
              </div>
            </div>
          </div>

          {/* Performance Operatori */}
          <div className="bg-white p-4 md:p-7" style={CARD_STYLE} data-id="element-430">
            <h2 style={{
          fontSize: '16px',
          fontWeight: 400,
          color: '#293B54',
          fontFamily: HEADING_FONT,
          margin: '0 0 20px 0'
        }} data-id="element-431">
              Performance Operatori
            </h2>

            <div className="overflow-x-auto" data-id="element-432">
              <div className="min-w-[500px]" data-id="element-433">
                {/* Table Header */}
                <div className="grid items-center" style={{
              gridTemplateColumns: '1fr 90px 90px 100px 110px',
              gap: '12px',
              padding: '0 0 12px 0',
              borderBottom: '1px solid #E4E4E4'
            }} data-id="element-434">
                  <div style={{
                fontSize: '11px',
                fontWeight: 500,
                color: '#AAAAAA',
                fontFamily: HEADING_FONT,
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }} data-id="element-435">
                    Operatore
                  </div>
                  <div style={{
                fontSize: '11px',
                fontWeight: 500,
                color: '#AAAAAA',
                fontFamily: HEADING_FONT,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                textAlign: 'right'
              }} data-id="element-436">
                    Gestiti
                  </div>
                  <div style={{
                fontSize: '11px',
                fontWeight: 500,
                color: '#AAAAAA',
                fontFamily: HEADING_FONT,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                textAlign: 'right'
              }} data-id="element-437">
                    Chiusi
                  </div>
                  <div style={{
                fontSize: '11px',
                fontWeight: 500,
                color: '#AAAAAA',
                fontFamily: HEADING_FONT,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                textAlign: 'right'
              }} data-id="element-438">
                    Successo
                  </div>
                  <div style={{
                fontSize: '11px',
                fontWeight: 500,
                color: '#AAAAAA',
                fontFamily: HEADING_FONT,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                textAlign: 'right'
              }} data-id="element-439">
                    Tempo Medio
                  </div>
                </div>

                {/* Operator Rows */}
                <div className="grid items-center" style={{
              gridTemplateColumns: '1fr 90px 90px 100px 110px',
              gap: '12px',
              padding: '14px 0',
              borderBottom: '1px solid #F5F5F5'
            }} data-id="element-440">
                  <div className="flex items-center gap-3" data-id="element-441">
                    <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  backgroundColor: '#293B54',
                  color: '#FFFFFF',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 500,
                  fontFamily: HEADING_FONT,
                  flexShrink: 0
                }} data-id="element-442">
                      MR
                    </div>
                    <div data-id="element-443">
                      <div style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#293B54'
                  }} data-id="element-444">
                        Marco Rossi
                      </div>
                    </div>
                  </div>
                  <div style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: HEADING_FONT,
                textAlign: 'right'
              }} data-id="element-445">
                    42
                  </div>
                  <div style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: HEADING_FONT,
                textAlign: 'right'
              }} data-id="element-446">
                    38
                  </div>
                  <div style={{
                textAlign: 'right'
              }} data-id="element-447">
                    <span style={{
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#293B54',
                  fontFamily: HEADING_FONT,
                  backgroundColor: 'rgba(42, 151, 223, 0.1)',
                  padding: '2px 8px',
                  borderRadius: '4px'
                }} data-id="element-448">
                      90.5%
                    </span>
                  </div>
                  <div style={{
                fontSize: '13px',
                color: '#444444',
                textAlign: 'right'
              }} data-id="element-449">
                    3.8 ore
                  </div>
                </div>

                <div className="grid items-center" style={{
              gridTemplateColumns: '1fr 90px 90px 100px 110px',
              gap: '12px',
              padding: '14px 0',
              borderBottom: '1px solid #F5F5F5'
            }} data-id="element-450">
                  <div className="flex items-center gap-3" data-id="element-451">
                    <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  backgroundColor: '#00497A',
                  color: '#FFFFFF',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 500,
                  fontFamily: HEADING_FONT,
                  flexShrink: 0
                }} data-id="element-452">
                      LB
                    </div>
                    <div data-id="element-453">
                      <div style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#293B54'
                  }} data-id="element-454">
                        Laura Bianchi
                      </div>
                    </div>
                  </div>
                  <div style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: HEADING_FONT,
                textAlign: 'right'
              }} data-id="element-455">
                    35
                  </div>
                  <div style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: HEADING_FONT,
                textAlign: 'right'
              }} data-id="element-456">
                    31
                  </div>
                  <div style={{
                textAlign: 'right'
              }} data-id="element-457">
                    <span style={{
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#293B54',
                  fontFamily: HEADING_FONT,
                  backgroundColor: 'rgba(42, 151, 223, 0.1)',
                  padding: '2px 8px',
                  borderRadius: '4px'
                }} data-id="element-458">
                      88.6%
                    </span>
                  </div>
                  <div style={{
                fontSize: '13px',
                color: '#444444',
                textAlign: 'right'
              }} data-id="element-459">
                    4.1 ore
                  </div>
                </div>

                <div className="grid items-center" style={{
              gridTemplateColumns: '1fr 90px 90px 100px 110px',
              gap: '12px',
              padding: '14px 0',
              borderBottom: '1px solid #F5F5F5'
            }} data-id="element-460">
                  <div className="flex items-center gap-3" data-id="element-461">
                    <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  backgroundColor: '#0E74B8',
                  color: '#FFFFFF',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 500,
                  fontFamily: HEADING_FONT,
                  flexShrink: 0
                }} data-id="element-462">
                      GV
                    </div>
                    <div data-id="element-463">
                      <div style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#293B54'
                  }} data-id="element-464">
                        Giuseppe Verdi
                      </div>
                    </div>
                  </div>
                  <div style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: HEADING_FONT,
                textAlign: 'right'
              }} data-id="element-465">
                    28
                  </div>
                  <div style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: HEADING_FONT,
                textAlign: 'right'
              }} data-id="element-466">
                    22
                  </div>
                  <div style={{
                textAlign: 'right'
              }} data-id="element-467">
                    <span style={{
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#E96E00',
                  fontFamily: HEADING_FONT,
                  backgroundColor: 'rgba(233, 110, 0, 0.08)',
                  padding: '2px 8px',
                  borderRadius: '4px'
                }} data-id="element-468">
                      78.6%
                    </span>
                  </div>
                  <div style={{
                fontSize: '13px',
                color: '#444444',
                textAlign: 'right'
              }} data-id="element-469">
                    5.2 ore
                  </div>
                </div>

                <div className="grid items-center" style={{
              gridTemplateColumns: '1fr 90px 90px 100px 110px',
              gap: '12px',
              padding: '14px 0',
              borderBottom: '1px solid #F5F5F5'
            }} data-id="element-470">
                  <div className="flex items-center gap-3" data-id="element-471">
                    <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  backgroundColor: '#2A97DF',
                  color: '#FFFFFF',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 500,
                  fontFamily: HEADING_FONT,
                  flexShrink: 0
                }} data-id="element-472">
                      AC
                    </div>
                    <div data-id="element-473">
                      <div style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#293B54'
                  }} data-id="element-474">
                        Anna Colombo
                      </div>
                    </div>
                  </div>
                  <div style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: HEADING_FONT,
                textAlign: 'right'
              }} data-id="element-475">
                    23
                  </div>
                  <div style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: HEADING_FONT,
                textAlign: 'right'
              }} data-id="element-476">
                    21
                  </div>
                  <div style={{
                textAlign: 'right'
              }} data-id="element-477">
                    <span style={{
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#293B54',
                  fontFamily: HEADING_FONT,
                  backgroundColor: 'rgba(42, 151, 223, 0.1)',
                  padding: '2px 8px',
                  borderRadius: '4px'
                }} data-id="element-478">
                      91.3%
                    </span>
                  </div>
                  <div style={{
                fontSize: '13px',
                color: '#444444',
                textAlign: 'right'
              }} data-id="element-479">
                    3.5 ore
                  </div>
                </div>

                <div className="grid items-center" style={{
              gridTemplateColumns: '1fr 90px 90px 100px 110px',
              gap: '12px',
              padding: '14px 0',
              borderBottom: '1px solid #F5F5F5'
            }} data-id="element-480">
                  <div className="flex items-center gap-3" data-id="element-481">
                    <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  backgroundColor: '#98C3EC',
                  color: '#FFFFFF',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 500,
                  fontFamily: HEADING_FONT,
                  flexShrink: 0
                }} data-id="element-482">
                      FN
                    </div>
                    <div data-id="element-483">
                      <div style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#293B54'
                  }} data-id="element-484">
                        Francesca Neri
                      </div>
                    </div>
                  </div>
                  <div style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: HEADING_FONT,
                textAlign: 'right'
              }} data-id="element-485">
                    18
                  </div>
                  <div style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: HEADING_FONT,
                textAlign: 'right'
              }} data-id="element-486">
                    15
                  </div>
                  <div style={{
                textAlign: 'right'
              }} data-id="element-487">
                    <span style={{
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#293B54',
                  fontFamily: HEADING_FONT,
                  backgroundColor: 'rgba(42, 151, 223, 0.1)',
                  padding: '2px 8px',
                  borderRadius: '4px'
                }} data-id="element-488">
                      83.3%
                    </span>
                  </div>
                  <div style={{
                fontSize: '13px',
                color: '#444444',
                textAlign: 'right'
              }} data-id="element-489">
                    4.6 ore
                  </div>
                </div>

                <div className="grid items-center" style={{
              gridTemplateColumns: '1fr 90px 90px 100px 110px',
              gap: '12px',
              padding: '14px 0'
            }} data-id="element-490">
                  <div className="flex items-center gap-3" data-id="element-491">
                    <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  backgroundColor: '#2A97DF',
                  color: '#FFFFFF',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 500,
                  fontFamily: HEADING_FONT,
                  flexShrink: 0
                }} data-id="element-492">
                      AC
                    </div>
                    <div data-id="element-493">
                      <div style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#293B54'
                  }} data-id="element-494">
                        Anna Colombo
                      </div>
                    </div>
                  </div>
                  <div style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: HEADING_FONT,
                textAlign: 'right'
              }} data-id="element-495">
                    23
                  </div>
                  <div style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: HEADING_FONT,
                textAlign: 'right'
              }} data-id="element-496">
                    21
                  </div>
                  <div style={{
                textAlign: 'right'
              }} data-id="element-497">
                    <span style={{
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#293B54',
                  fontFamily: HEADING_FONT,
                  backgroundColor: 'rgba(42, 151, 223, 0.1)',
                  padding: '2px 8px',
                  borderRadius: '4px'
                }} data-id="element-498">
                      91.3%
                    </span>
                  </div>
                  <div style={{
                fontSize: '13px',
                color: '#444444',
                textAlign: 'right'
              }} data-id="element-499">
                    3.5 ore
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Distribuzione Carico */}
          <div className="bg-white p-4 md:p-7" style={CARD_STYLE} data-id="element-500">
            <h2 style={{
          fontSize: '16px',
          fontWeight: 400,
          color: '#293B54',
          fontFamily: HEADING_FONT,
          margin: '0 0 20px 0'
        }} data-id="element-501">
              Distribuzione Carico di Lavoro
            </h2>
            <div className="flex flex-col gap-4" data-id="element-502">
              <div className="flex items-center gap-3" style={{
            minHeight: '28px'
          }} data-id="element-503">
                <div className="w-[100px] md:w-[140px] flex-shrink-0 text-[13px] text-[#444444] font-roboto" data-id="element-504">
                  Marco Rossi
                </div>
                <div className="flex-1" style={{
              height: '20px',
              backgroundColor: '#F0F1F3',
              borderRadius: '3px',
              overflow: 'hidden'
            }} data-id="element-505">
                  <div style={{
                height: '100%',
                width: '100%',
                backgroundColor: '#293B54',
                borderRadius: '0 3px 3px 0'
              }} data-id="element-506" />
                </div>
                <span style={{
              fontFamily: HEADING_FONT,
              fontSize: '14px',
              fontWeight: 500,
              color: '#293B54',
              minWidth: '48px',
              textAlign: 'right',
              flexShrink: 0
            }} data-id="element-507">
                  42
                </span>
              </div>

              <div className="flex items-center gap-3" style={{
            minHeight: '28px'
          }} data-id="element-508">
                <div className="w-[100px] md:w-[140px] flex-shrink-0 text-[13px] text-[#444444] font-roboto" data-id="element-509">
                  Laura Bianchi
                </div>
                <div className="flex-1" style={{
              height: '20px',
              backgroundColor: '#F0F1F3',
              borderRadius: '3px',
              overflow: 'hidden'
            }} data-id="element-510">
                  <div style={{
                height: '100%',
                width: `${35 / 42 * 100}%`,
                backgroundColor: '#00497A',
                borderRadius: '0 3px 3px 0'
              }} data-id="element-511" />
                </div>
                <span style={{
              fontFamily: HEADING_FONT,
              fontSize: '14px',
              fontWeight: 500,
              color: '#293B54',
              minWidth: '48px',
              textAlign: 'right',
              flexShrink: 0
            }} data-id="element-512">
                  35
                </span>
              </div>

              <div className="flex items-center gap-3" style={{
            minHeight: '28px'
          }} data-id="element-513">
                <div className="w-[100px] md:w-[140px] flex-shrink-0 text-[13px] text-[#444444] font-roboto" data-id="element-514">
                  Giuseppe Verdi
                </div>
                <div className="flex-1" style={{
              height: '20px',
              backgroundColor: '#F0F1F3',
              borderRadius: '3px',
              overflow: 'hidden'
            }} data-id="element-515">
                  <div style={{
                height: '100%',
                width: `${28 / 42 * 100}%`,
                backgroundColor: '#0E74B8',
                borderRadius: '0 3px 3px 0'
              }} data-id="element-516" />
                </div>
                <span style={{
              fontFamily: HEADING_FONT,
              fontSize: '14px',
              fontWeight: 500,
              color: '#293B54',
              minWidth: '48px',
              textAlign: 'right',
              flexShrink: 0
            }} data-id="element-517">
                  28
                </span>
              </div>

              <div className="flex items-center gap-3" style={{
            minHeight: '28px'
          }} data-id="element-518">
                <div className="w-[100px] md:w-[140px] flex-shrink-0 text-[13px] text-[#444444] font-roboto" data-id="element-519">
                  Anna Colombo
                </div>
                <div className="flex-1" style={{
              height: '20px',
              backgroundColor: '#F0F1F3',
              borderRadius: '3px',
              overflow: 'hidden'
            }} data-id="element-520">
                  <div style={{
                height: '100%',
                width: `${23 / 42 * 100}%`,
                backgroundColor: '#2A97DF',
                borderRadius: '0 3px 3px 0'
              }} data-id="element-521" />
                </div>
                <span style={{
              fontFamily: HEADING_FONT,
              fontSize: '14px',
              fontWeight: 500,
              color: '#293B54',
              minWidth: '48px',
              textAlign: 'right',
              flexShrink: 0
            }} data-id="element-522">
                  23
                </span>
              </div>

              <div className="flex items-center gap-3" style={{
            minHeight: '28px'
          }} data-id="element-523">
                <div className="w-[100px] md:w-[140px] flex-shrink-0 text-[13px] text-[#444444] font-roboto" data-id="element-524">
                  Francesca Neri
                </div>
                <div className="flex-1" style={{
              height: '20px',
              backgroundColor: '#F0F1F3',
              borderRadius: '3px',
              overflow: 'hidden'
            }} data-id="element-525">
                  <div style={{
                height: '100%',
                width: `${18 / 42 * 100}%`,
                backgroundColor: '#98C3EC',
                borderRadius: '0 3px 3px 0'
              }} data-id="element-526" />
                </div>
                <span style={{
              fontFamily: HEADING_FONT,
              fontSize: '14px',
              fontWeight: 500,
              color: '#293B54',
              minWidth: '48px',
              textAlign: 'right',
              flexShrink: 0
            }} data-id="element-527">
                  18
                </span>
              </div>
            </div>
          </div>

          {/* Riepilogo Gestione */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-528">
            <div className="bg-white flex flex-col justify-between p-4 md:p-6" style={CARD_STYLE} data-id="element-529">
              <div className="mb-3" data-id="element-530">
                <Icon icon="tabler:users" fontSize={22} style={{
              color: '#2A97DF',
              strokeWidth: 1.5
            }} data-id="element-531" />
              </div>
              <div data-id="element-532">
                <div style={{
              fontFamily: 'Roboto Condensed, sans-serif',
              color: '#293B54',
              lineHeight: 1.2
            }} className="text-[24px] font-[400]" data-id="element-533">
                  5
                </div>
                <div style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '14px',
              color: '#80858E',
              marginTop: '4px'
            }} data-id="element-534">
                  Operatori Attivi
                </div>
                <div style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '12px',
              color: '#AAAAAA',
              marginTop: '4px'
            }} data-id="element-535">
                  Media 29.2 ticket/operatore
                </div>
              </div>
            </div>

            <div className="bg-white flex flex-col justify-between p-4 md:p-6" style={CARD_STYLE} data-id="element-536">
              <div className="mb-3" data-id="element-537">
                <Icon icon="tabler:trophy" fontSize={22} style={{
              color: '#2A97DF',
              strokeWidth: 1.5
            }} data-id="element-538" />
              </div>
              <div data-id="element-539">
                <div style={{
              fontFamily: 'Roboto Condensed, sans-serif',
              color: '#293B54',
              lineHeight: 1.2
            }} className="text-[24px] font-[400]" data-id="element-540">
                  Anna Colombo
                </div>
                <div style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '14px',
              color: '#80858E',
              marginTop: '4px'
            }} data-id="element-541">
                  Miglior Tasso Chiusura
                </div>
                <div className="flex items-center gap-1" style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '12px',
              color: '#2A97DF',
              marginTop: '4px'
            }} data-id="element-542">
                  <Icon icon="tabler:trending-up" fontSize={14} data-id="element-543" />
                  <span data-id="element-544">91.3% successo · 3.5 ore tempo medio</span>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}